import { render, staticRenderFns } from "./SwabSamplesResultsTableBody.vue?vue&type=template&id=423b453c&scoped=true&"
import script from "./SwabSamplesResultsTableBody.vue?vue&type=script&lang=ts&"
export * from "./SwabSamplesResultsTableBody.vue?vue&type=script&lang=ts&"
import style0 from "./SwabSamplesResultsTableBody.vue?vue&type=style&index=0&id=423b453c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b453c",
  null
  
)

export default component.exports